import { SCENE_INTERACTION } from "../../../constants/scene";
import { FEATURE_NAMES } from "../../MVC/rolesHelper";
import { SCENE_EVENTS } from "../../MVC/EVENTS/ModelEvents";
import { AiTokensModal } from "./AiTokensModal";

export class SpaceInfoModal {
  constructor({ model, socket }) {
    this.model = model;
    this.socket = socket;
    this.wrapper = $("#show-space-info");
    this.closeButton = this.wrapper.find("#close-space-info");
    this.editRoomButton = this.wrapper.find("#showSpaceEditRoom");
    this.personAddButton = this.wrapper.find(".person_add");
    this.title = this.wrapper.find(".space-info-title");
    this.closeModalButton = this.wrapper.find("#close-show-space-edit-room");
    this.aiTokensModal = new AiTokensModal({ model });
    this.init();
  }

  init() {
    this.bindEvents();
    this.loadData();
  }


  bindEvents() {
    // Close modal when clicking close button
    this.closeButton.on("click", () => {
      this.hide();
    });

    this.closeModalButton.on("click", () => {
      this.hide();
    });

    // Close modal when clicking background
    this.wrapper.find(".modal-background").on("click", () => {
      this.hide();
    });

    // Handle edit room button click
    this.editRoomButton.on("click", () => {
      this.hide();
      // Trigger edit room functionality
      this.model.dispatchEvent({ type: "EDIT_ROOM" });
    });

    // Handle person add button click
    this.personAddButton.on("click", async () => {
      // Copy the URL with the specified parameter to the clipboard
      navigator.clipboard.writeText(`${window.location.href}&autoseat=true`).then(() => {
        // Optional: Provide visual feedback to the user
        this.model.alert('success', $trans('success-world-name-copied'));
        this.hide();
      }).catch(err => {
        console.error("Failed to copy text: ", err);
      });
    });

    // Close modal on escape key
    $(document).on("keydown", (e) => {
      if (e.key === "Escape" && this.isVisible()) {
        this.hide();
      }
    });
  }

  show() {
    this.wrapper.addClass("is-active");
    this.aiTokensModal?.syncIcon();
    this.loadSpaceInfo();
    this.loadData();
  }

  hide() {
    this.wrapper.removeClass("is-active");
  }

  isVisible() {
    return this.wrapper.hasClass("is-active");
  }

  loadSpaceInfo() {
    // Load current space information
    const currentScene = this.model.currentScene;
    if (currentScene) {
      // Update space info content
      this.updateSpaceInfo(currentScene);
    }
  }
  loadData() {
    this.model.worldFetcher.getProfileInfo(this.model.sceneData.creatorUserIdOfWorld,
      (response) => {
        this.updateSpaceInfo(response.data);
      });
    this.title.text(this.model.sceneData.name || this.model.sceneData.publicName);
  }

  updateSpaceInfo(scene) {
    // Update the space info content with current scene data
    const spaceInfoContent = this.wrapper.find(".space-info-content-wrapper");

    // You can customize this content based on what information you want to display
    const spaceInfo = `
      <div class="space-info-details">
        <div class="space-info-item">
          <strong><span data-lang="space-author-label">Author:</span> ${scene.username}</strong>
        </div>
        <div class="space-info-item">
          <strong></strong>
        </div>
        ${this.model.sceneData.description}
      </div>
    `;

    spaceInfoContent.html(spaceInfo);
    if (typeof multiLanguagesController !== 'undefined') {
      multiLanguagesController.renderLanguage();
    }
  }
}
